var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isRouterAlive)?_c('div',{staticClass:"loading"},[_c('WaitBox',{attrs:{"reqCount":_vm.reqCount}})],1):_c('div',{staticClass:"view-box"},[(false)?_c('FixBox'):_vm._e(),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }